import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

 const CultureList=()=>request({
  url: ApiURL.Query.GetCultureList,
  method: RequestType.GET,
 });

 const ApplicationList=()=>request({
  url: ApiURL.Query.GetApplicationList,
  method: RequestType.GET,
 });
 const LocalizationManagementQuery = {
  CultureList,  
  ApplicationList
};

export default LocalizationManagementQuery;